import axios from "axios";
import EventBus from "../../event-bus";

function removeFromLocalStorage() {
  localStorage.removeItem("username");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("timezone");
  localStorage.removeItem("resources");
  localStorage.removeItem("locale");
  localStorage.removeItem("avatar");
  localStorage.removeItem("dark_mode");
  delete axios.defaults.headers.common["Authorization"];
}

export default {
  state: {
    status: "",
    error: "",
    username: localStorage.getItem("username") || "",
    access_token: localStorage.getItem("access_token") || "",
    refresh_token: localStorage.getItem("refresh_token") || "",
    timezone: JSON.parse(localStorage.getItem("timezone")) || {},
    resources: JSON.parse(localStorage.getItem("resources")) || {},
    locale: localStorage.getItem("locale") || "",
    avatar: localStorage.getItem("avatar") || null,
    dark_mode: localStorage.getItem("dark_mode") || null,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";
      state.username = data.username;
      state.access_token = data.access_token;
      state.refresh_token = data.refresh_token;
      state.timezone = data.timezone;
      state.resources = data.resources;
      state.locale = data.locale;
      state.avatar = data.avatar;
      state.dark_mode = data.dark_mode;
    },
    auth_error(state, data) {
      state.status = "error";
      state.error = data.error;
    },
    auth_refresh(state, data) {
      state.access_token = data.access_token;
      state.resources = data.resources;
    },
    logout(state) {
      state.status = "";
      state.access_token = "";
      state.refresh_token = "";
      state.timezone = "";
      state.resources = "";
      state.locale = "";
      state.avatar = null;
      state.dark_mode = null;
    },
    setAvatar(state, data) {
      // If avatar was removed it must be removed from localStorage to enable displaying avatar letter.
      if (data.avatar == null) {
        localStorage.removeItem("avatar");
      }
      state.avatar = data.avatar;
    },
    setDarkMode(state, data) {
      if (data.darkMode == null) {
        localStorage.removeItem("dark_mode");
      }
      state.dark_mode = data.dark_mode;
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/api/login",
          data: { username: user.username, password: user.password },
          headers: { Locale: user.locale },
          method: "POST",
        })
          .then((response) => {
            if (response.data.status == "success") {
              let username = response.data.username;
              let access_token = response.data.access_token;
              let refresh_token = response.data.refresh_token;
              let timezone = response.data.timezone;
              let resources = response.data.resources;
              let locale = response.data.locale;
              let avatar = null;
              let dark_mode = null;

              localStorage.setItem("username", username);
              localStorage.setItem("access_token", access_token);
              localStorage.setItem("refresh_token", refresh_token);
              localStorage.setItem("timezone", JSON.stringify(timezone));
              localStorage.setItem("resources", JSON.stringify(resources));
              localStorage.setItem("locale", locale);

              if ("avatar" in response.data) {
                avatar = response.data.avatar.small;
                localStorage.setItem("avatar", avatar);
              }
                
              if ("dark_mode" in response.data) {
                dark_mode = response.data.dark_mode;
                localStorage.setItem("dark_mode", dark_mode);
              } else {
                localStorage.removeItem("dark_mode");
              }

              axios.defaults.headers.common["Authorization"] =
                "Bearer " + access_token;

              commit("auth_error", { error: "" });
              commit("auth_success", {
                username: username,
                access_token: access_token,
                refresh_token: refresh_token,
                timezone: timezone,
                resources: resources,
                locale: locale,
                dark_mode: dark_mode,
                avatar: avatar,
              });

              resolve(response);
            } else {
              commit("auth_error", { error: response.data.error });
              reject(response);
            }
          })
          .catch((err) => {
            removeFromLocalStorage();
            commit("auth_error", { error: err });
            reject(err);
          });
      });
    },

    refresh({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/api/refresh",
          data: {
            access_token: state.access_token,
            refresh_token: state.refresh_token,
          },
          method: "POST",
        })
          .then((response) => {
            if (response.data.status == "success") {
              let access_token = response.data.access_token;
              let resources = response.data.resources;
              let old_resources = state.resources;

              // If permissions has changed show modal.
              if (JSON.stringify(old_resources) != JSON.stringify(resources)) {
                EventBus.$emit("SHOW_PERMISSION_CHANGE_MODAL");
              }

              localStorage.setItem("access_token", access_token);
              localStorage.setItem("resources", JSON.stringify(resources));

              axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.access_token;

              commit("auth_refresh", {
                access_token: access_token,
                resources: resources,
              });

              resolve(response);
            } else {
              commit("auth_error", { error: response.data.error });
              resolve(response);
            }
          })
          .catch((err) => {
            commit("auth_error", { error: err });
            reject(err);
          });
      });
    },

    logout({ commit }, errorMessage) {
      return new Promise((resolve) => {
        commit("auth_error", { error: errorMessage });
        commit("logout");
        removeFromLocalStorage();
        resolve();
      });
    },

    setAvatar({ commit }, data) {
      localStorage.setItem("avatar", data.avatar);
      commit("setAvatar", data);
    },

    setDarkMode({ commit }, data) {
      localStorage.setItem("dark_mode", data.dark_mode);
      commit("setDarkMode", data);
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.access_token,
    accessToken: (state) => state.access_token,
    timezone: (state) => state.timezone,
    resources: (state) => state.resources,
    locale: (state) => state.locale,
    darkMode: (state) => state.dark_mode,
    avatar: (state) => state.avatar,
    username: (state) => state.username,
  },
};
